<template>
  <grid-page-loading-error
    v-if="error !== null && !loading"
    @retry="init"
  />
  <m-spinner
    v-else-if="loading"
    class="_spinner"
  />
  <div
    :class="['_container', { '-table': gridPageTileChart.chartType === gridPageChartType.table }]"
  >
    <m-content
      class="grid-page-tile-chart"
      :padding-x="10"
      :padding-bottom="6"
    >
      <grid-page-chart
        :chart-data-query="chartDataQuery"
        :chart="gridPageTileChart"
      />
    </m-content>
  </div>
</template>

<script setup>
import GridPageChart from '@/components/custom-grid/chart/GridPageChart.vue';
import GridPageLoadingError from '@/components/custom-grid/GridPageLoadingError.vue';
import useChartDataQuery from '@/composables/chart-data-query';
import useGridPage from '@/composables/grid-page/grid-page-repo';
import { computed, ref } from 'vue';
import { gridPageChartType } from 'shared/constants.json';
import { logCatch } from '@/lib/logger/logger';

const props = defineProps({ gridPageTile: { type: Object, required: true } });

const gridPageSvc = useGridPage();
const gridPageTileChart = computed(() => {
  const res = gridPageSvc.gridPageTileChart.value.find((e) => e.tile.uid === props.gridPageTile.uid);
  if (res === undefined) {
    return {};
  }

  return res;
});

const chartDataQuery = useChartDataQuery(gridPageTileChart);

const error = ref(null);
const loading = ref(false);
const init = () => {
  loading.value = true;
  error.value = null;
  gridPageSvc.queryGridPageTileChartByTile(props.gridPageTile)
    .catch(logCatch((e) => {
      error.value = e;
    }))
    .finally(() => {
      loading.value = false;
    });
};

init();
</script>

<style scoped lang="scss">
._container {
  width: 100%;
  height: calc(100% - 6rem);
  display: flex;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;

  .grid-page-tile-chart {
    width: 100%;
    height: 100%;
    display: flex;
  }

  &.-table {
    overflow: auto;

    .grid-page-tile-chart {
      display: inline-table;
    }
  }
}

._spinner {
  min-height: calc(100% - 6rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
